<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <Input :maxlength="100" v-model="searchForm.dictTopic" placeholder="请输入字典主题" />
                <Input :maxlength="100" v-model="searchForm.dictName" placeholder="请输入字典名称" />
                <Button type="primary" v-if="buttonMenu['/dictionary/view']" @click="getData()">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button type="primary" v-if="buttonMenu['/dictionary/add']" @click="handleOpenEditModal()">添加</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
          <Table :data="tableData" :columns="columns">
            <template #action="{row}">
                <div>
                    <a style="margin-left: 10px;" v-if="buttonMenu['/dictionary/edit']" @click="handleOpenEditModal(row)">编辑</a>
                    <Poptip confirm title="确定要删除吗？" v-if="buttonMenu['/dictionary/delete']" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>

                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        </div>
        <Modal v-model="editVisible" :title="(form.id?'编辑':'新增')+'字典值'">
            <Form @submit.native.prevent :label-width="100" v-if="editVisible" :model="form" ref="formRef">
                <FormItem label="字典主题：" :rules="[{required:true,message:'请输入字典主题'}]" prop="dictTopic">
                    <Input :maxlength="100" v-model="form.dictTopic" />
                </FormItem>
                <FormItem label="字典名称：" :rules="[{required:true,message:'请输入字典名称'}]" prop="dictName">
                    <Input :maxlength="100" v-model="form.dictName" />
                </FormItem>
                <FormItem label="字典值：" :rules="[{required:true,message:'请输入字典值'}]" prop="dictValue">
                    <Input type="textarea" autosize :maxlength="4096" v-model="form.dictValue" />
                </FormItem>
                <FormItem label="字典描述：" prop="dictDesc">
                    <Input :maxlength="100" v-model="form.dictDesc" />
                </FormItem>
                <FormItem label="排序值：" :rules="[{required:true,message:'请输入排序值'}]" prop="dictSort">
                    <InputNumber :min="0" v-model="form.dictSort" :max="99999" />
                </FormItem>
            </Form>
            <template #footer>
                <Button @click="editVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getDictionaryList, addDictionary, delDictionary, editDictionary, getDictionaryInfo } from '@/api/dictionary'
export default {
  components: {
    Pages
  },
  data() {
    return {
      editVisible:false,
      form:{},
      submitLoading: false,
      searchForm:{},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        // {
        //   title: 'id',
        //   key: 'id'
        // },
        {
          title: '字典主题',
          key: 'dictTopic'
        },
        {
          title: '字典名称',
          key: 'dictName'
        },
        {
          title: '字典值',
          key: 'dictValue',
          tooltip: true,
          tooltipMaxWidth: 300
        },
        {
          title: '描述',
          key: 'dictDesc'
        },
        {
          title: '排序值',
          key: 'dictSort'
        },
        {
          title: '创建人',
          key: 'createUserName'
        },
        {
          title: '创建时间',
          key: 'createTimeFmt'
        },
        {
          title: '修改人',
          key: 'updateUserName'
        },
        {
          title: '修改时间',
          key: 'updateTimeFmt'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('system/dictionary')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getDictionaryList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        console.log(data)

        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getDictionaryInfo(row.id)
        this.form = r.data
      } else {
        this.form = {
          dictSort: 0
        }
      }
      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(r => {
        if (r) {
          const func = this.form.id ? editDictionary : addDictionary
          this.submitLoading = true
          func({
            ...this.form
          }).then(r => {
            this.$Message.success('操作成功')
            this.getData()
            this.submitLoading = false
            this.editVisible = false
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleDel(row) {
      delDictionary(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form{
    display:flex;
    &>*{
        margin: 0 5px;
    }
}
.layout-card{
  /deep/ .ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
</style>
